import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import { Wrapper } from './UnfinishedBannerStyles';

const UnfinishedBanner = ({ description, title }) => (
  <Wrapper>
    <h1>{title}</h1>
    <p>{description}</p>
  </Wrapper>
);

UnfinishedBanner.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string
};

UnfinishedBanner.defaultProps = {
  description: 'Thanks for stopping by. Just to let you know, the content for this page is not quite complete. Please check back in the next few weeks!',
  title: 'This page is a work in progress'
};

export default UnfinishedBanner;



// WEBPACK FOOTER //
// ./src/components/UnfinishedBanner/UnfinishedBanner.jsx